import request from '@/auth/jwt/request'

/**
 * @description 客户预约单 -- 查询列表
 * id = 0 新增
 * @param {Object} param params {Object} 传值参数
 */
export const appointmentListApi = params => { return request('subscribe-order/list', 'get', params) }

/**
 * @description 客户预约单 -- 审核
 * { id = x }
 */
export const appointmentVerifyApi = data => { return request('subscribe-order/verify', 'put', {}, data) }

/**
 * @description 客户预约单 --- 项目下拉
 * @param {Object} param params {Object} 传值参数
 */
export const appointmentProjectList = params => { return request('pull-down/projectSelect', 'get', params) }